/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// state
import { TStore } from '@store/index';
import { StateCreator } from 'zustand';

// datatable organizations
import { tableSchemaBase as columns } from '../organizations.columns';

// types
import { TColumnsSchema } from '@global-types/index';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IOrganizationsDatatableSlice {
	organizationsDatatableOptions: TColumnsSchema[];
	setOrganizationsDatatableOptions: (
		_organizationsDatatableOptions: TColumnsSchema[]
	) => void;
}

/* -------------------------------------------------------------------------- */
/*                                    Slice                                   */
/* -------------------------------------------------------------------------- */

export const partializeOrganizationsDatatableSlice = (
	s: any
): any => ({
	organizationsDatatableOptions:
		s.organizationsDatatableOptions,
});

const initialState = {
	organizationsDatatableOptions: columns.filter(
		(item) => item.defaultVisible
	),
};

export const createOrganizationsDatatableSlice: StateCreator<
	TStore,
	[['zustand/persist', unknown]],
	[],
	IOrganizationsDatatableSlice
> = (set) => ({
	...initialState,
	setOrganizationsDatatableOptions: (
		_organizationsDatatableOptions: TColumnsSchema[]
	) =>
		set({
			organizationsDatatableOptions:
				_organizationsDatatableOptions,
		}),
});
